import _ from "lodash";

export const emailVerifier = (email) => {
    return (
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        .test(email)
    );
};

export const isEqual = (x, y) => {
  return _.isEqual(x,y);
};

export const cloneDeep = (x) => {
    return _.cloneDeep(x);
};

export const phoneVerifier = (phone) => {
    return (
        /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:\d)?\s?\d{4})-?(\d{4}))$/
        .test(phone)
    );
};

export const seiNumberVerifier = (seiNumber) => {
    return (
        /^\w{10}\.\w{6}\/\w{4}-\w{2}$/.test(seiNumber)
    );
};
